(() => {
  var intervalId = window.setInterval(function () {
    if (document.getElementsByClassName("tier-cart-grid").length) {
      var cartGrid = document.getElementsByClassName("tier-cart-grid")[0];
      var discount = document.getElementsByClassName(
        "tier-discount-cart-amount"
      )[0];
      const totalRowDiscount = `
                
        		<div class='tier-cart-tag'><h3 class="totals__subtotal">Mix & Save</h3> <i class="material-icons tier-inline-icon">local_offer</i></div>
    			<div class="tier-cart-grid">
    				${discount.innerHTML}
    		    </div>
    		`;
      removeElementByClass("tier-discount-cart-amount");
      removeElementByClass("tier-cart-hr");
      removeElementByClass("total-value-price");
      var discountEl = document.createElement("div");
      discountEl.classList = ["totals-row"];

      var totalsRow = document.getElementsByClassName("totals");
      totalsRow[0].insertBefore(discountEl, totalsRow[0].children[2]);
      discountEl.innerHTML = totalRowDiscount;

      function removeElementByClass(className) {
        var elements = document.getElementsByClassName(className);
        while (elements.length > 0) {
          elements[0].parentNode.removeChild(elements[0]);
        }
      }
    }
  }, 500);
})();
